module.exports = __webpack_public_path__ + "img/icon_baobiao.474ab60c.png";